module.exports = __webpack_public_path__ + "static/media/rtc-bg@2x.38476ed3.png";